export default __webpack_public_path__ + "static/media/jQuery_-_adamr.space___Codecademy.fb1016ec.pdf";